import { render, staticRenderFns } from "./WorkStatusChip.vue?vue&type=template&id=9abc2950"
import script from "./WorkStatusChip.vue?vue&type=script&lang=js"
export * from "./WorkStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports